import Tip from 'components/tip/Tip';
import { spacing } from 'modules/metrics';
import { ToastContainer } from 'react-toastify';
import styled, { createGlobalStyle } from 'styled-components';

import { black, darkGray, white } from '../../modules/colors';

export const GlobalStyle = createGlobalStyle`

  /* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
	*/

	html, body, div, span, applet, object, iframe,
	h1, h2, h3, h4, h5, h6, p, blockquote, pre,
	a, abbr, acronym, address, big, cite, code,
	del, dfn, em, img, ins, kbd, q, s, samp,
	small, strike, strong, sub, sup, tt, var,
	b, u, i, center,
	dl, dt, dd, ol, ul, li,
	fieldset, form, label, legend,
	table, caption, tbody, tfoot, thead, tr, th, td,
	article, aside, canvas, details, embed,
	figure, figcaption, footer, header, hgroup,
	menu, nav, output, ruby, section, summary,
	time, mark, audio, video {
		margin: 0;
		padding: 0;
		border: 0;
		font-size: 100%;
		font: inherit;
		vertical-align: baseline;
	}
	/* HTML5 display-role reset for older browsers */
	article, aside, details, figcaption, figure,
	footer, header, hgroup, menu, nav, section {
		display: block;
	}
	body {
		line-height: 1;
	}
	ol, ul {
		list-style: none;
	}
	blockquote, q {
		quotes: none;
	}
	blockquote:before, blockquote:after,
	q:before, q:after {
		content: '';
		content: none;
	}
	table {
		border-collapse: collapse;
		border-spacing: 0;
	}

	body {
			color: ${darkGray};
		}

	*, body {
			font-family: "Ubuntu", sans-serif;
		}

	html {
    scroll-behavior: smooth;
  }

	/* TOOLTIP-START */
	.__react_component_tooltip {
		border-radius: 3px;
		display: inline-block;
		font-size: 13px;
		left: -999em;
		opacity: 0;
		padding: 8px 21px;
		position: fixed;
		pointer-events: none;
		transition: opacity 0.3s ease-out;
		top: -999em;
		visibility: hidden;
		z-index: 999;
		max-width: 250px;

		&.allow_hover,
		&.allow_click {
			pointer-events: auto;
		}

		&::before,
		&::after {
			content: "";
			width: 0;
			height: 0;
			position: absolute;
		}

		&.show {
			opacity: 0.9;
			margin-top: 0;
			margin-left: 0;
			visibility: visible;
		}

		// Place
		&.place-top {
			&::before {
				border-left: 10px solid transparent;
				border-right: 10px solid transparent;
				bottom: -8px;
				left: 50%;
				margin-left: -10px;
			}
		}

		&.place-bottom {
			&::before {
				border-left: 10px solid transparent;
				border-right: 10px solid transparent;
				top: -8px;
				left: 50%;
				margin-left: -10px;
			}
		}

		&.place-left {
			&::before {
				border-top: 6px solid transparent;
				border-bottom: 6px solid transparent;
				right: -8px;
				top: 50%;
				margin-top: -5px;
			}
		}

		&.place-right {
			&::before {
				border-top: 6px solid transparent;
				border-bottom: 6px solid transparent;
				left: -8px;
				top: 50%;
				margin-top: -5px;
			}
		}

		// Wrapping
		.multi-line {
			display: block;
			padding: 2px 0;
			text-align: left !important;
		}
	}
	/* TOOLTIP-End */

  @keyframes fadein {
	  from { opacity: 0; }
  	to   { opacity: 1; }
  }

	@keyframes flickerAnimation {
		0%   { opacity:1; }
		50%  { opacity:0; }
		100% { opacity:1; }
	}

	.animate-flicker {
		[class^='Tipstyles__Wrapper'] {
    	animation: flickerAnimation 2s infinite;
		}
	}


	@media print {
		[class^='TroubleshootingRequeststyles__TitleWrapper'],[class^='Header-styles__Wrapper'],
		[class^='HeroUser-styles__HeroChildren'],
		[class^='Hero-styles__ButtonWrapper'],
		[class^='InfoBox-styles__Wrapper'], [class^='ServiceRequest-styles__SupplierServiceFiles'],
		[class^='Footer-styles__Wrapper'],
		[class^='Offer-styles__SupplierRating'],[class^='Button-styles__Wrapper'],[class^='ServiceRequestInfo-styles__Description'],
		[class^='TroubleshootingRequestInfo-styles__Description'], [class^='Chat-styles__ChatWrapper'],
		[class^='Chat-styles__Attachments'],
		 [class^='DefaultLogo-styles__Wrapper'],
		[class^='Offer-styles__Line'],
		[class^='TroubleshootingRequestInfo-styles__ShipFlagDetail'],
		[class^='ServiceRequest-styles__CanceledAndWithdrawnOffers'],
		.__react_component_tooltip,
		[class^='ServiceRequest-styles__SuppliersWithNoOffer'],
		[class$='Port_Tip'],
		[class$='Gallery_Tip'],
		[class$='Travelling_Tip'],
		[class$='AgentInformation_Tip'],
		[class$='Billing_Tip'],
		[class$='SelectedSuppliers_Tip'],
		[class$='Print_Tip'],
		[class^='OfferExcerpt-styles__Image'],
		[class^='ServiceRequestInfo-styles__ShipFlagDetail'],
		[class^='ServiceRequest-styles__ChatWithShippingCompany'],
    [class^='ExportShipServicesCompany-styles__Wrapper'],
    [class^='ExportRatingsCompany-styles__Wrapper']
		{
			display: none !important;
		}

		[class^='Card-styles__Wrapper'] {
			border-left: none !important;
		}

		[class^='Offer-styles__SupplierName']{
			> img {
				display: none !important;
			}
		}

		[class^='PrintService-styles__Wrapper'], [class^='Offer-styles__PaymentTerm'],
		[class$='TotalCost_Label']{
			display: block;
			color: ${black};
			line-height: 1.5;
		}

		[class^='ServiceRequestInfo-styles__ShipCountryDetail'],
		[class^='TroubleshootingRequestInfo-styles__ShipCountryDetail'],
		[class^='ServiceRequestInfo-styles__PrintDescription'],
		[class^='TroubleshootingRequestInfo-styles__PrintDescription'] {
			display: flex;
			color: ${white};
			line-height: 1.5;
		}

		[class^='ServiceRequestInfo-styles__Wrapper'],
		[class^='ServiceRequestInfo-styles__Description'],
		[class^='PageWrapper-styles__Content'], [class^='ServiceRequestInfo-styles__Detail'],
		[class^='ServiceRequestInfo-styles__Info'],
		[class^='TroubleshootingRequestInfo-styles__Wrapper'],
		[class^='ServiceRequest-styles__TitleWrapper'],
		[class^='ServiceRequest-styles__Offers']
		{
			color: ${white};
			line-height: 1.5;
		}

     /* For export services */
    body.export-services-printing [class*='PrintServiceForExportServices'],
    body.export-ratings-printing [class*='PrintRating'] {
      page-break-inside: avoid !important;
      break-inside: avoid !important; /* Modern browsers */
    }

		[class^='Hero-styles__Title'], [class^='Hero-styles__Heading']{
			display: flex;
			background-color: ${black};
      color: ${black}!important;
			line-height: 1.5;
		}

		[class^='Hero-styles__Wrapper']{
			padding: 0 !important;
			background: ${white}!important;
		}

		[class^='PageWrapper-styles__Content']{
			background: ${white}!important;
		}

     /* Add these rules for Offer-styles__Wrapper */
    [class^='Offer-styles__Wrapper'] {
      color: ${black} !important;
    }

    /* Make all children black */
    [class^='Offer-styles__Wrapper'] * {
      color: ${black} !important;
    }

		[class^='ServiceRequestInfo-styles__Wrapper'],
		[class^='Tag-styles__Wrapper'] {
			background: ${black} !important;
      color: black !important;
		}

     /* Add this new rule to make all children black */
    [class^='ServiceRequestInfo-styles__Wrapper'] * {
      color: ${black} !important;
    }

    /* For specific child elements that might have white text */
    [class^='ServiceRequestInfo-styles__ShipCountryDetail'],
    [class^='ServiceRequestInfo-styles__PrintDescription'] {
      color: ${black} !important;
    }

    [class^='ServiceRequestInfo-styles__ShipCountryDetail'] *,
    [class^='ServiceRequestInfo-styles__PrintDescription'] * {
      color: ${black} !important;
    }

		// fixes visibility of converted total cost
		[class^='OfferExcerpt-styles__Tips'] {
			margin-top:8px;
		}

		// offerExcerpt's Tips
		[class$='Info_Tip'], [class$='Message_Tip'], [class$='Warning_Tip'],
	 [class$='ChatWithSupplier_Wrapper'] {
			display: none !important;
		}

	// Tips in Service/troubleshootingRequestInfo (Port & Flag)
		[class$='OnlyForPrint_Tip']
		{
			display:flex !important;
			color: ${white};
		}

}
`;

export const Wrapper = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const Content = styled.div`
  flex: 1;
`;

export const TipStyled = styled(Tip)`
  position: fixed;
  bottom: 80px;
  right: 30px;
  z-index: 10;
`;

export const ToastContainerStyled = styled(ToastContainer)`
  margin-top: ${spacing.xxl}px;
`;

export const Main = styled.main``;
